import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Quote from './icon-goal-quote.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Quote {...validProps} />;
}
SvgComponent.iconName = 'goal-quote';

/**
 * @deprecated This is a legacy icon
 */
export const GoalQuoteIcon = svgIconWrapper(SvgComponent);
